import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dossierCompetencePath: "./cv/Dossier_competences_2104.pdf",
    linkedinPath: "https://www.linkedin.com/in/trivis-emmanuel-8a21813a/",
    maltPath: "https://www.malt.fr/profile/emmanueltrivis",
  },
  mutations: {},
  actions: {},
  modules: {},
});
